/**
 * Empty State Component
 * Displays helpful guidance when MIDI is not connected
 * Uses EmptyState from ui-components for layout
 */

import { EmptyState as EmptyStateUI } from '@midi-volca-drum/ui-components';

interface EmptyStateProps {
  onConnectClick: () => void;
}

const MidiIcon = () => (
  <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='32' cy='32' r='28' stroke='currentColor' strokeWidth='3' fill='none' />
    <path d='M32 20V36M32 44V44.5' stroke='currentColor' strokeWidth='3' strokeLinecap='round' />
  </svg>
);

const STEPS = [
  { title: 'Connect your Volca Drum via USB or MIDI interface' },
  { title: 'Click the connection button to set up MIDI' },
  { title: 'Grant MIDI access when prompted by your browser' },
];

export const EmptyState = ({ onConnectClick }: EmptyStateProps) => {
  return (
    <EmptyStateUI
      icon={<MidiIcon />}
      title='MIDI Not Connected'
      description='Connect your Volca Drum to start editing parameters in real-time.'
      steps={STEPS}
      actionLabel='CONNECT MIDI DEVICE'
      onAction={onConnectClick}
      note='Requires Chrome, Edge, or Opera browser with Web MIDI API support'
    />
  );
};
